import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["fields"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { formatLanguageCode } from 'i18n/options';
import Divider from 'components/Divider';
import Panel from 'components/Panel';
import { ConfirmationModal } from 'screens/ContentEditorModals';
import { useLinkEditorForm } from 'screens/ContentEditorModals/editorForms';
import { formatAssetEditorPayloadForApi } from 'screens/AssetEditor';
import ModalWrapper from './ModalWrapper';
import GeneralDetailsPanel from './Panels/GeneralDetailsPanel';
import LinkDetailsPanel from './Panels/LinkDetailsPanel';
import InParentPlaylistPanel from './Panels/InParentPlaylistPanel';
import { useUpdateAssets, useDeleteAsset } from 'actions/assets';
import filterObject from 'utils/filterObject';
import { OPTIONAL } from 'utils/asset/completionModes';
import isMultiDomain from 'utils/isMultiDomain';
var VIEWS = {
  DETAILS: 'details',
  CONFIRMATION: 'confirmation'
};
function LinkEditorModal(_ref) {
  var _modals;
  var onClose = _ref.onClose,
    content = _ref.content,
    parentPlaylist = _ref.parentPlaylist,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    i18n = _useTranslation.i18n;
  var defaultLocale = parentPlaylist.locale || formatLanguageCode(i18n.language);
  var _useState = useState(VIEWS.DETAILS),
    _useState2 = _slicedToArray(_useState, 2),
    view = _useState2[0],
    setView = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSubmissionLoading = _useState4[0],
    setIsSubmissionLoading = _useState4[1];
  var _useUpdateAssets = useUpdateAssets({
      assetIds: [content.id],
      parentPlaylistId: parentPlaylist.id
    }),
    updateAssets = _useUpdateAssets.updateAssets;
  var _useDeleteAsset = useDeleteAsset({
      assetId: content.id
    }),
    isDeleting = _useDeleteAsset.isLoading,
    softDeleteAsset = _useDeleteAsset.deleteAsset;
  var _useLinkEditorForm = useLinkEditorForm(content, defaultLocale),
    fields = _useLinkEditorForm.fields,
    form = _objectWithoutProperties(_useLinkEditorForm, _excluded);
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _fields$externalRefId;
      var contentData, cleanedContentData, assetUpdate;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            contentData = {
              name: fields.name.value,
              webUrl: fields.webUrl.value,
              description: fields.description.changedValue,
              locale: fields.locale.value,
              tags: fields.tags.changedValue,
              thumbnailId: fields.thumbnailId.changedValue,
              customType: fields.customType.value,
              completionTime: fields.completionTime.wasChanged ? Number(fields.completionTime.value) : undefined,
              openInIframe: fields.openInIframe.value,
              parentId: fields.parentId.wasChanged ? fields.parentId.changedValue : content.parentId,
              optional: fields.completionMode.wasChanged ? fields.completionMode.value === OPTIONAL : undefined,
              markAsDoneMode: fields.markAsDoneMode.value,
              externalRefId: fields.externalRefId.wasChanged ? ((_fields$externalRefId = fields.externalRefId.value) === null || _fields$externalRefId === void 0 ? void 0 : _fields$externalRefId.trim()) || null : undefined
            };
            cleanedContentData = filterObject(contentData); // Add flag for setting asset to published
            cleanedContentData.published = true;
            _context.prev = 3;
            setIsSubmissionLoading(true);
            _context.next = 7;
            return updateAssets(formatAssetEditorPayloadForApi({
              parentPlaylistId: parentPlaylist.id,
              changes: cleanedContentData
            }));
          case 7:
            assetUpdate = _context.sent;
            // Use local optional state in case asset has not yet been inserted into assetCollections
            assetUpdate.optional = cleanedContentData.optional;
            _context.next = 15;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            setIsSubmissionLoading(false);
            return _context.abrupt("return");
          case 15:
            if (!parentPlaylist.id) {
              _context.next = 25;
              break;
            }
            _context.prev = 16;
            _context.next = 19;
            return onSubmit(assetUpdate);
          case 19:
            setIsSubmissionLoading(false);
            onClose();
            _context.next = 25;
            break;
          case 23:
            _context.prev = 23;
            _context.t1 = _context["catch"](16);
          case 25:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11], [16, 23]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var deleteAsset = function deleteAsset() {
    softDeleteAsset();
    onClose();
  };
  var isParentPlaylistDistributed = isMultiDomain(parentPlaylist);
  var modals = (_modals = {}, _defineProperty(_modals, VIEWS.DETAILS, /*#__PURE__*/React.createElement(ModalWrapper, {
    isLoading: isSubmissionLoading,
    isSubmitDisabled: form.hasErrors,
    assetContentType: content.type,
    onSubmit: handleSubmit,
    onClose: function onClose() {
      return setView(VIEWS.CONFIRMATION);
    }
  }, /*#__PURE__*/React.createElement(GeneralDetailsPanel, {
    fields: fields,
    content: content
  }), parentPlaylist && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(InParentPlaylistPanel, {
    isDisabled: isParentPlaylistDistributed,
    completionMode: fields.completionMode.value,
    parentPlaylistName: parentPlaylist.name,
    onCompletionModeChange: function onCompletionModeChange(newMode) {
      return fields.completionMode.set(newMode);
    }
  }))), /*#__PURE__*/React.createElement(LinkDetailsPanel, {
    id: "link-details-panel",
    lastUpdated: content.lastUpdated,
    fields: fields,
    content: content
  }))), _defineProperty(_modals, VIEWS.CONFIRMATION, /*#__PURE__*/React.createElement(ConfirmationModal, {
    isLoading: isDeleting,
    onConfirm: deleteAsset,
    onCancel: function onCancel() {
      return setView(VIEWS.DETAILS);
    },
    isEditMode: false
  })), _modals);
  return modals[view];
}
export default LinkEditorModal;